import getApi from '../../../api/apisauceConfig'

export const deleteDoctolibPendingPatientData = (id: number) =>
  getApi().delete<void>(`/patients/${id}/pending_changes/batch`)
